import { useEffect, useState } from 'react'
import { Props } from './Layout'
import { useGameInfo } from '@/src/stores/Games/useGames'

export type Params = {
  visible: boolean
  selectedGame: string
  onClickClose: () => void
  onClickAccept: (gameId: string) => void
}

export const useProps = (params: Params): Props => {
  const { visible, selectedGame, onClickClose, onClickAccept } = params
  const [hotGames, setHotGames] = useState<Props['hotGames']>([])
  const [allGames, setAllGames] = useState<Props['allGames']>([])
  const [selectGame, setSelectGame] = useState<Props['selectGame']>(selectedGame)
  const [selectCategory, setSelectCategory] = useState<Props['selectCategory']>('ALL_GAME')

  const { games } = useGameInfo()

  useEffect(() => {
    // AllGamesは古いゲーム順
    setAllGames([...games.filter((g) => !g.onlyTournament)])
    // HotGames
    setHotGames(
      games
        .reverse()
        .filter((g) => !g.onlyTournament)
        .filter((g) => g.hotGame),
    )
  }, [visible])

  useEffect(() => {
    if (hotGames.findIndex((e) => e.id === selectGame) !== -1) setSelectCategory('HOT_GAME')
  }, [hotGames])

  return {
    visible,
    hotGames,
    allGames,
    selectedGame,
    selectGame,
    selectCategory,
    onClickGame: (gameId, category) => {
      setSelectGame(gameId)
      setSelectCategory(category)
    },
    onClickClose,
    onClickAccept: () => onClickAccept(selectGame),
  }
}
